
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

define('component!settings/AccountSettingsModalComponent',['require','react','create-react-class','translate','component!settings/ExtensionVoucherTabComponent','component!ModalComponent'],function (require) {
  'use strict';

  var React = require('react');
  var ReactCreateClass = require('create-react-class');
  var t = require('translate');

  var ExtensionVoucherTab = require('component!settings/ExtensionVoucherTabComponent');

  var ModalComponent = require('component!ModalComponent');

  var AccountSettingsModalComponent = ReactCreateClass({
    displayName: 'AccountSettingsModalComponent',

    getDefaultProps: function getDefaultProps() {
      return {
        isOpen: false
      };
    },

    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      this.modal = React.createRef();
    },

    render: function render() {
      return React.createElement(
        'div',
        { className: 'account-settings-modal-component' },
        React.createElement(
          ModalComponent,
          _extends({ ref: this.modal }, this.props),
          React.createElement(
            'header',
            null,
            React.createElement(
              'h1',
              { className: 'header-title account-settings-modal-component__header' },
              t('Extensions #settings_modal')
            )
          ),
          React.createElement(
            'section',
            { className: 'account-settings-modal-component__section' },
            React.createElement(ExtensionVoucherTab, null)
          )
        )
      );
    },

    open: function open() {
      this.modal.current.open();
    },

    close: function close() {
      this.modal.current.close();
    }

  });

  return AccountSettingsModalComponent;
});
